import React, { Suspense, useEffect, useState } from 'react';
import { AuthRoot } from '@bbkAdminComponents/app-layout/auth-root';
import { LogInPaths } from '@bbkAdminComponents/log-in-flow/log-in-paths';
import { PreparingOverlay } from '@bbkAdminComponents/preparing-overlay/preparing-overlay';
import { preauthCompanySlice } from '@bbkAdminRedux/rtkq/preauth-company.slice';
import { usePollAndNotifyVersion } from '@bbkAdminRedux/rtkq/version.slice';
import { LogoutPage } from '@bbkAdminRouter/logout.page';
import { SignupPaths } from '@bbkAdminRouter/signup-paths';
import { correctBaseURI } from '@bbkAdminUtils/getCurrentBaseUri';
import { GlobalLogger } from '@bbkAdminUtils/GlobalLogger';
import { Route, Switch } from '@bbkShared/react-router';
import { useBbkFavicon } from '@bbkShared/utils/favicon';

import '@bbkAdminStylesheets/tailwind.scss';

const SignupRouter = React.lazy(() => import('@bbkAdminRouter/signup.router'));
const CBIDPExchange = React.lazy(
  () => import('@bbkAdminComponents/log-in-flow/cbidp-exchange')
);

// ATTN: Keep routes simple, no logic
// Only Simple <Route path={path}><PageComponent /></Route>
const AdminAppRouter = () => (
  <Suspense fallback={<PreparingOverlay message="" />}>
    <Switch>
      <Route path={LogInPaths.logout}>
        <LogoutPage />
      </Route>
      <Route path={LogInPaths.cbidpExchange}>
        <CBIDPExchange />
      </Route>
      <Route path={SignupPaths.trialSignup}>
        <SignupRouter />
      </Route>
      <Route>
        <AuthRoot />
      </Route>
    </Switch>
  </Suspense>
);

export const AdminApp: React.FC = () => {
  usePollAndNotifyVersion();
  useBbkFavicon();

  const [isLoadingFinished, setIsLoadingFinished] = useState<boolean>();
  const [getClientConfig$] =
    preauthCompanySlice.endpoints.getClientConfig.useLazyQuery();

  useEffect(() => {
    getClientConfig$()
      .unwrap()
      .then((config) => correctBaseURI(config))
      .catch(GlobalLogger.error)
      .finally(() => setIsLoadingFinished(true));
  }, [getClientConfig$]);

  if (!isLoadingFinished) return null;

  return <AdminAppRouter />;
};
